import Button from 'views/Dashboards-B2B/components/Button';
import * as S from './OutstandingInvoices.styled';

export interface OutstandingInvoice {
    id: string; // Stripe invoice ID (e.g., inv_xxxxx)
    invoice_number: string;
    total_amount: number;
    currency: string;
    status: string; // 'open', 'paid', etc.
    due_date: string | null;
    days_overdue?: number;
    created: string;
    hosted_invoice_url: string | null;
    invoice_pdf: string | null;
}

interface OutstandingInvoicesProps {
    invoices: OutstandingInvoice[];
    onViewInvoice: (invoice: OutstandingInvoice) => void;
    onPayNow: (invoice: OutstandingInvoice) => void;
}

export default function OutstandingInvoices({
    invoices,
    onViewInvoice,
    onPayNow,
}: OutstandingInvoicesProps) {
    return (
        <div>
            <S.SectionHeader>
                <S.SectionTitle>Outstanding Invoices</S.SectionTitle>
                {invoices.length > 0 && <S.CountBadge>{invoices.length}</S.CountBadge>}
            </S.SectionHeader>

            {invoices.length === 0 ? (
                <S.TableWrapper>
                    <S.EmptyState>No outstanding invoices</S.EmptyState>
                </S.TableWrapper>
            ) : (
                <S.TableWrapper>
                    <S.Table>
                        <thead>
                            <tr>
                                <S.TableHeader>Invoice #</S.TableHeader>
                                <S.TableHeader>Date</S.TableHeader>
                                <S.TableHeader>Due Date</S.TableHeader>
                                <S.TableHeader>Amount</S.TableHeader>
                                <S.TableHeader>Status</S.TableHeader>
                                <S.TableHeader>Actions</S.TableHeader>
                            </tr>
                        </thead>
                        <tbody>
                            {invoices.map((invoice) => (
                                <S.TableRow key={invoice.id}>
                                    <S.TableCell>{invoice.invoice_number}</S.TableCell>
                                    <S.TableCell>
                                        {new Date(invoice.created).toLocaleDateString()}
                                    </S.TableCell>
                                    <S.TableCell>
                                        {invoice.due_date
                                            ? new Date(invoice.due_date).toLocaleDateString()
                                            : 'N/A'}
                                        {invoice.days_overdue && invoice.days_overdue > 0 && (
                                            <span style={{ color: 'red', marginLeft: '4px' }}>
                                                ({invoice.days_overdue} days overdue)
                                            </span>
                                        )}
                                    </S.TableCell>
                                    <S.TableCell>
                                        ${invoice.total_amount.toFixed(2)}{' '}
                                        {invoice.currency.toUpperCase()}
                                    </S.TableCell>
                                    <S.TableCell>
                                        <S.StatusBadge>
                                            {invoice.status === 'open' ? 'Unpaid' : invoice.status}
                                        </S.StatusBadge>
                                    </S.TableCell>
                                    <S.TableCell>
                                        <S.ActionButtons>
                                            {invoice.hosted_invoice_url && (
                                                <Button
                                                    border="purple"
                                                    color="purple"
                                                    onClick={() => onViewInvoice(invoice)}
                                                    style={{
                                                        padding: '8px 16px',
                                                        height: 'auto',
                                                        marginRight: '8px',
                                                    }}
                                                >
                                                    View
                                                </Button>
                                            )}
                                            {invoice.invoice_pdf && (
                                                <Button
                                                    border="purple"
                                                    color="purple"
                                                    onClick={() =>
                                                        window.open(
                                                            invoice.invoice_pdf as string,
                                                            '_blank'
                                                        )
                                                    }
                                                    style={{
                                                        padding: '8px 16px',
                                                        height: 'auto',
                                                        marginRight: '8px',
                                                    }}
                                                >
                                                    Download PDF
                                                </Button>
                                            )}
                                            {invoice.status === 'open' && (
                                                <Button
                                                    background="purple"
                                                    onClick={() => onPayNow(invoice)}
                                                    style={{ padding: '8px 16px', height: 'auto' }}
                                                >
                                                    Pay Now
                                                </Button>
                                            )}
                                        </S.ActionButtons>
                                    </S.TableCell>
                                </S.TableRow>
                            ))}
                        </tbody>
                    </S.Table>
                </S.TableWrapper>
            )}
        </div>
    );
}
